export default {
  title: 'ndsc_gallery_title',
  images: [
    {
      original: require("@ndsc/assets/images/DSC01944.jpg"),
      description: "Training by Bitlabs.id",
      thumbnail: require("@ndsc/assets/images/DSC01944.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02189.jpg"),
      description: "Training by Bitlabs.id",
      thumbnail: require("@ndsc/assets/images/DSC02189.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02371.jpg"),
      description: "Training by Arkademy",
      thumbnail: require("@ndsc/assets/images/DSC02371.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02362.jpg"),
      description: "Training by Arkademy",
      thumbnail: require("@ndsc/assets/images/DSC02362.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02357.jpg"),
      description: "Training by Cybertrend Data Academy",
      thumbnail: require("@ndsc/assets/images/DSC02357.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02320.jpg"),
      description: "Training by Cybertrend Data Academy",
      thumbnail: require("@ndsc/assets/images/DSC02320.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02373.jpg"),
      description: "Training by She Loves Data",
      thumbnail: require("@ndsc/assets/images/DSC02373.jpg")
    },
    {
      original: require("@ndsc/assets/images/DSC02317.jpg"),
      description: "Training by She Loves Data",
      thumbnail: require("@ndsc/assets/images/DSC02317.jpg")
    },

    {
      original: require("@ndsc/assets/images/BINARY24.jpg"),
      description: "Training by Binar Academy",
      thumbnail: require("@ndsc/assets/images/BINARY24.jpg")
    },
    {
      original: require("@ndsc/assets/images/BINARY5.jpg"),
      description: "Training by Binar Academy",
      thumbnail: require("@ndsc/assets/images/BINARY5.jpg")
    },
    {
      original: require("@ndsc/assets/images/IMG_1317.JPG"),
      description: "Advanced Training at Universitas Indonesia",
      thumbnail: require("@ndsc/assets/images/IMG_1317.JPG")
    },
    {
      original: require("@ndsc/assets/images/HMSF1032.JPG"),
      description: "Advanced Training at Universitas Indonesia",
      thumbnail: require("@ndsc/assets/images/HMSF1032.JPG")
    }
  ]
}